import { carmaGenericImageLoader } from 'src/general/helpers/carmaGenericImageLoader';

const loadImage = (src: string, width: number): Promise<HTMLImageElement | null> =>
  new Promise((resolve) => {
    const img = new Image();

    img.src = carmaGenericImageLoader({ src, width });
    img.onload = () => {
      resolve(img);
    };
    img.onerror = () => {
      resolve(null);
    };
  });

export const loadImages = (images: string[], width: number) => Promise.all(images.map((src) => loadImage(src, width)));

export const drawImageInCanvas = (image: HTMLImageElement | null, canvas: HTMLCanvasElement | null) => {
  if (image && canvas) {
    // Resize the canvas if needed
    if (canvas.width !== canvas.clientWidth) {
      canvas.width = canvas.clientWidth * 2;
    }
    if (canvas.height !== canvas.clientHeight) {
      canvas.height = canvas.clientHeight * 2;
    }

    const context = canvas.getContext('2d');
    if (context && image.width > 0 && image.height > 0) {
      context.drawImage(image, 0, 0, image.width, image.height, 0, 0, context.canvas.width, context.canvas.height);
    }
  }
};

export const ensureValueInRange = (value: number, rangeLength: number) => {
  let newIndex = value;
  while (newIndex >= rangeLength) {
    newIndex -= rangeLength;
  }
  while (newIndex < 0) {
    newIndex += rangeLength;
  }
  return newIndex;
};
